<script lang="ts">
    import type DataProvider from "../services/data.provider";
    import type ServiceProvider from "../services/service.provider";
    import type { Category } from "../interfaces/interfaces";

    export let dataProvider: DataProvider;
    export let serviceProvider: ServiceProvider;

    let categoryList: Category[] = [];
    let errorCategories = false;
    let processingCategories = false;

    serviceProvider.searchService.categoryListSubs.subscribe(
        (data) => {
            categoryList = data;
            dataProvider = dataProvider;
        }
    );

    serviceProvider.searchService.errorCategoriesSubs.subscribe(
        (status) => (errorCategories = status)
    );

    serviceProvider.searchService.processingCategoriesSubs.subscribe(
        (status) => (processingCategories = status)
    );

    const onSubmit = (): void => serviceProvider.searchService.submitSearch();

    const onReset = (): void => {
        dataProvider.resetFilter();
        serviceProvider.searchService.submitSearch();
        dataProvider = dataProvider;
    };

    const onArchivIncludedChanged = (): void => {
        serviceProvider.searchService.loadCategories(dataProvider.archiveIncluded)

        onSubmit()
    }
</script>

<div>
    <!-- kvuli margin-top: * + .bno-grid -->
</div>
<form
    class="bno-grid bno-grid--x5"
    aria-label="Vyhledávání"
    on:submit|preventDefault={onSubmit}
    on:reset|preventDefault={onReset}
>
    <div class="bno-grid__tile bno-grid__tile--merge-2">
        <div class="bno-search bno-search--with-checkbox">
            <div class="bno-search__inner">
                <div class="bno-form-control">
                    <input
                        id="input-search"
                        bind:value={dataProvider.searchString}
                        class="bno-form-control__input bno-form-control__input--standalone"
                        type="text"
                        aria-required="false"
                        aria-disabled="false"
                        autocomplete="off"
                        placeholder={dataProvider.placeholder}
                    />
                    <label
                        class="bno-form-control__label u-sr-only"
                        for="input-search"
                    >
                        Hledat
                    </label>
                </div>
                <div class="bno-form-control bno-form-control--custom">
                    <input
                        name="archived"
                        id="search-archive"
                        type="checkbox"
                        class="bno-form-control__checkbox"
                        aria-required="false"
                        aria-disabled="false"
                        bind:checked={dataProvider.archiveIncluded}
                        on:change={onArchivIncludedChanged}
                    />
                    <span class="bno-form-control__indicator" />
                    <label class="bno-form-control__label" for="search-archive">
                        Prohledávat včetně archivu
                    </label>
                </div>
                <button
                    class="bno-button bno-button--secondary"
                    type="submit"
                    aria-label="Odeslat formulář vyhledávání"
                >
                    Hledat
                </button>
            </div>
        </div>
    </div>
    <div class="bno-grid__tile">
        <div class="bno-form-control">
            <div class="bno-select">
                <select
                    name="field"
                    id="select-field"
                    aria-required="false"
                    aria-disabled="false"
                    bind:value={dataProvider.field}
                    on:change={onSubmit}
                >
                    <option value="">Všechny oblasti</option>

                    {#each dataProvider.fields as option}
                        <option value={String(option.id)}>{option.name}</option>
                    {/each}
                </select>
                <label
                    class="bno-form-control__label u-sr-only"
                    for="select-field"
                >
                    Všechny oblasti
                </label>
            </div>
        </div>
    </div>
    <div class="bno-grid__tile">
        <div class="bno-form-control">
            {#if errorCategories}
                <span>Nastala chyba při načítání kategorií.</span>
            {:else if categoryList.length}
                <div class="bno-select">
                    <select
                        name="category"
                        id="select-category"
                        aria-required="false"
                        disabled={processingCategories}
                        aria-disabled={processingCategories}
                        bind:value={dataProvider.category}
                        on:change={onSubmit}
                    >
                        <option value="">
                            Všechny kategorie
                        </option>

                        {#each categoryList as option}
                            <option
                                value={String(option.id)}
                                selected={dataProvider.category === String(option.id)}
                            >
                                {option.name}
                            </option>
                        {/each}
                    </select>
                    <label
                        class="bno-form-control__label u-sr-only"
                        for="select-category"
                    >
                        Všechny kategorie
                    </label>
                </div>
            {/if}
        </div>
    </div>
</form>
